var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"block-header"},[_c('bread-crumb')],1),(_vm.roleId != '')?_c('RoleComponent',{attrs:{"title":'EditRole',"type":'edit',"roleId":this.roleId},on:{"Close":_vm.close}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }